import { CourseriddenService } from '../../Services/courseridden.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-courseridden-list',
    template: require('./courseridden-list.component.html'),
    styles: [require('./courseridden-list.component.css')]
})
export class CourseriddenListComponent implements OnInit {
    coursesRidden: any[] = [];
    currentYear = new Date();

    coursesRiddenPerDay: any = {};
    totalsPerDay: any = {};
    keys: any[] = [];

    constructor(private courseRiddenService: CourseriddenService) { }

    ngOnInit() {

        this.courseRiddenService.getAllCoursesRidden().subscribe(
            cr => {
                this.coursesRidden = cr;
                // console.log(this.coursesRidden);

                this.coursesRidden.forEach(element => {
                    if (!this.coursesRiddenPerDay.hasOwnProperty(element.date)){
                        this.coursesRiddenPerDay[element.date] = [];
                        this.keys.push(element.date);
                    }

                    this.coursesRiddenPerDay[element.date].push(element)
                });

                this.keys = Object.keys(this.coursesRiddenPerDay).sort(
                    function (a, b) {
                      var nameA = new Date(a);
                      var nameB = new Date(b);

                      if (nameA < nameB) //sort string Descending
                        return 1;
                      if (nameA > nameB)
                        return -1;
                      return 0; //default return value (no sorting)
            
                    });
                // console.log(this.keys);
               
                // console.log('-----------------------------');
                
                this.keys.forEach(k => {
                    var amount = 0;
                    this.coursesRiddenPerDay[k].forEach((item:any) => {
                        amount += item.courseMembers.length;
                    });
                    if (!this.totalsPerDay.hasOwnProperty(k)){
                        this.totalsPerDay[k]={};
                    }
                    this.totalsPerDay[k].total = amount ;
                });
                // console.log(this.coursesRiddenPerDay);
                // console.log(this.totalsPerDay);
                
            }
        );

    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/courseridden-list/courseridden-list.component.ts